(function () {
  "use strict";

  var SHOWN = "fnd-mv-shown";

  // Buyer's currency + country, from Shopify's own head globals.
  // Both are matchable, so class="show-for-gbp show-for-au" works.
  function getTokens() {
    var s = window.Shopify || {};
    var out = [];
    var cur = s.currency && s.currency.active;
    if (cur) out.push(String(cur).toLowerCase());
    if (s.country) out.push(String(s.country).toLowerCase());
    return out;
  }

  // className is an SVGAnimatedString on SVG elements — getAttribute is safe everywhere.
  function classesOf(el) {
    return (el.getAttribute("class") || "").trim().split(/\s+/);
  }

  function apply() {
    var tokens = getTokens();
    if (!tokens.length) return;

    // Build the ~= selectors. Whole-class match, so hide-for-us won't catch hide-for-usa.
    var hideSel = tokens
      .map(function (t) { return '[class~="hide-for-' + t + '"]'; })
      .join(",");

    document.querySelectorAll(hideSel).forEach(function (el) {
      el.style.display = "none";
      el.classList.remove(SHOWN);
    });

    document.querySelectorAll('[class*="show-for-"]').forEach(function (el) {
      var wanted = classesOf(el)
        .filter(function (c) { return c.indexOf("show-for-") === 0; })
        .map(function (c) { return c.slice(9); })
        .filter(Boolean);

      // No parseable target (e.g. only-show-for-gb) — leave it alone rather than
      // hiding it in every market forever.
      if (!wanted.length) return;

      // Already hidden by a hide-for- rule this pass; don't resurrect it.
      if (el.style.display === "none" && !el.classList.contains(SHOWN)) return;

      var match = wanted.some(function (w) { return tokens.indexOf(w) !== -1; });

      if (match) {
        el.style.display = "";
        el.classList.add(SHOWN);
      } else {
        el.style.display = "none";
        el.classList.remove(SHOWN);
      }
    });
  }

  function init() {
    apply();

    // Cart drawer, quick view, variant swaps and Section Rendering API responses
    // all inject markup after load. Re-run on any subtree change.
    if (window.MutationObserver && document.body) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () {
          queued = false;
          apply();
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  // custom.js is deferred, so DOMContentLoaded may already have fired.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();